export const DSB_PROGRAM_CODE = 'PFP_PE_DSB_PGRM_AP'
